import "./App.css";
import { Navigate, Route, Routes } from "react-router-dom";
import {
  Box,
  CircularProgress,
  StyledEngineProvider,
  ThemeProvider,
} from "@mui/material";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Categories from "./pages/Categories";
import Stock from "./pages/Stock";
import PaymentMethods from "./pages/PaymentMethods";
import Profile from "./pages/Profile";
import theme from "./utils/materialTheme";
import Signup from "./pages/Signup";
import { UserContext } from "./contexts/userContext";
import Menu from "./pages/Menu";
import PublicMenu from "./pages/PublicMenu";
import KitchenOrders from "./pages/KitchenOrders";
import { useContext } from "react";
import SalesList from "./components/SalesList";
import Ingredients from "./pages/Ingredients";
import Promotions from "./pages/Promotions";
import { AlertProvider } from "./contexts/alertContext";

const PrivateRoute = ({ children }: any) => {
  const { isAuthenticated, userData } = useContext(UserContext);
  if (!isAuthenticated || userData.role === "KITCHEN") {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  const { loading } = useContext(UserContext);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ width: "100vw", backgroundColor: "#fcf9ef", height: "100vh" }}
      >
        <CircularProgress size={200} />
      </Box>
    ); // Muestra un spinner o mensaje de carga
  }
  return (
    <AlertProvider>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              <Route index element={<Home />} />
              <Route path="stock" element={<Stock />} />
              <Route path="categories" element={<Categories />} />
              <Route path="ingredients" element={<Ingredients />} />
              <Route path="promotions" element={<Promotions />} />
              <Route path="payment-methods" element={<PaymentMethods />} />
              <Route path="sell-list" element={<SalesList />} />
              <Route path="profile" element={<Profile />} />
              <Route path="menu" element={<Menu />} />
            </Route>
            <Route path="/orders" element={<KitchenOrders />} />
            <Route path="/public-menu/:id" element={<PublicMenu />} />
          </Routes>
        </ThemeProvider>
      </StyledEngineProvider>
    </AlertProvider>
  );
}

export default App;
